import { render, staticRenderFns } from "./ContractorChips.vue?vue&type=template&id=fbcd698c"
import script from "./ContractorChips.vue?vue&type=script&lang=ts"
export * from "./ContractorChips.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fbcd698c')) {
      api.createRecord('fbcd698c', component.options)
    } else {
      api.reload('fbcd698c', component.options)
    }
    module.hot.accept("./ContractorChips.vue?vue&type=template&id=fbcd698c", function () {
      api.rerender('fbcd698c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/companyProjects/ContractorChips.vue"
export default component.exports